// extracted by mini-css-extract-plugin
export default {"headerSec":"home_headerSec__YLfNL","selectBox":"home_selectBox__jeUUT","donationWrap":"home_donationWrap__E89yS","heatMap":"home_heatMap__AbEpT"};